import Sort from "components/molecules/Sort";
import React, { ChangeEvent } from "react";
import "./index.scss";

interface ProductSortSimpleProps {
  sort?: string;
  count: number;
  total: number;
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const ProductSortSimple: React.FC<ProductSortSimpleProps> = ({
  sort,
  count,
  total,
  handleChange,
}) => (
  <section className="o-product-sort-result">
    <Sort sort={sort} handleChange={handleChange} />
    <div className="o-product-sort-result-bottom">
      Có {count}/{total} Sản Phẩm
    </div>
  </section>
);

export default React.memo(ProductSortSimple);
